export enum QuestionStatus {
  CREATED = 'CREATED',
  CORRECT = 'CORRECT',
  FAILED = 'FAILED',
  TIMEOUT = 'TIMEOUT',
}
